import api from 'api';

export const loadUsers = api('GET /api/partner-companies/fields/users');

export const loadActiveUsers = api(
  'GET /api/partner-companies/fields/users/active'
);

export const loadCountries = api('GET /api/partner-companies/fields/countries');

export const loadTimeZones = api('GET /api/partner-companies/fields/timezones');
